import { reverse } from 'named-urls'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'

import type { EmptyStateProps, TableData } from '@fourthwall/components'
import { EmptyState, List, Table, useMediaQueryContext } from '@fourthwall/components'
import { useWebViewBridge } from '@fourthwall/webview-bridge'
import type { LocationState } from '@types'
import { routing } from '@utils/routing'

import { type GiftCard } from '../../GiftCards.types'
import { isGiftCardGroup } from '../../utils/isGiftCardGroup'
import { GiftCardListItem } from '../GiftCardListItem/GiftCardListItem'
import { TABLE_HEADERS } from './consts'

type GiftCardsDataProps = {
  data: TableData<GiftCard>[]
  isLoading: boolean
  emptyStateProps: EmptyStateProps
}

const getGiftCardLink = (giftCard: any, locationState: LocationState) => {
  const giftCardId = isGiftCardGroup(giftCard) ? giftCard.groupId : giftCard.id

  return {
    pathname: reverse(routing.promotions.giftCards.giftCard.self, {
      giftCardId,
    }),
    search: location.search,
    state: locationState,
  }
}

export const GiftCardsData = ({ data, isLoading, emptyStateProps }: GiftCardsDataProps) => {
  const media = useMediaQueryContext()
  const location = useLocation()
  const { isWebView } = useWebViewBridge()
  const emptyComponent = <EmptyState {...emptyStateProps} />
  const shouldShowLoading = isWebView ? data.length === 0 : true

  const locationState: LocationState = {
    from: { label: 'Promotions', location },
  }

  if (!media.tablet) {
    return (
      <List
        data={data}
        isLoading={isLoading && shouldShowLoading}
        getItemLink={(giftCard) => getGiftCardLink(giftCard, locationState)}
        renderItem={(giftCard: GiftCard) => <GiftCardListItem giftCard={giftCard} />}
        emptyComponent={emptyComponent}
        locationState={locationState}
      />
    )
  }

  return (
    <Table
      data={data}
      headers={TABLE_HEADERS}
      isLoading={isLoading}
      rowComponent={Link}
      emptyComponent={emptyComponent}
      getRowLink={(giftCard) => getGiftCardLink(giftCard, locationState)}
    />
  )
}
